import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { fadeInUp400ms } from '../../../../../@vex/animations/fade-in-up.animation';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'vex-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  animations: [fadeInUp400ms]
})
export class ForgotPasswordComponent implements OnInit {

  form = this.fb.group({
    email: [null, Validators.required]
  });
  success = false;
  message = "";
  error = new BehaviorSubject<string>(null);
  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private authService: AuthService
  ) { }

  ngOnInit() {
  }

  send() {
    var email = this.form.value.email;
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }
    this.authService.forgotPassword(email).subscribe({
      next: response => {
        if(response.status == 200){
          this.success = true;
          this.message = response.result;
        }
      }, error: error => {
        if(error){
          this.success = false;
          this.error.next(error.error.message);
        }
      }
    });
  }
}
